export enum IUserFlowRedirectionCondition {
    PRESENT = 'present',
    CHANGED = 'changed',
    ABSENT = 'absent',
}

export enum IUserFlowTriggerCondition {
    INIT,
    NAVIGATION,
    PUSH_ADD_CHANGE,
    PUSH_REMOVE
}

export interface IUserFlowBuilder {
    config: {
        flows: {
            tagName: string;
            tagValue: string;
            pageUrl: string;
            redirectionCondition: IUserFlowRedirectionCondition;
        }[];
    };
    tagName: string;
}
